import PosthogService from '~/services/posthog/PosthogService';

export interface IConfirmCandidateOverviewClickedPayload {
  postingId: string;
  professionalId: string;
  interviewId: string;
  shiftId?: string;
  offerId?: string;
}

/**
 * Fires when an office clicks to view the candidate overview on the Confirm Candidate page
 * Event: dental_portal:confirm_candidate:overview_clicked
 */
export function fireConfirmCandidateOverviewClicked(
  payload: IConfirmCandidateOverviewClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:confirm_candidate:overview_clicked', {
    posting_id: payload.postingId,
    professional_id: payload.professionalId,
    interview_id: payload.interviewId,
    shift_id: payload.shiftId,
    offer_id: payload.offerId,
  });
}
